import Axios  from "axios"

export const getLogs = () => async (dispatch) => {
    dispatch({ type: 'LOG_LOADING' })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/admin/log/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'LOG_GET_SUCCESS',
                payload: data.logs
            }) 
        }

    } catch (error) {
        dispatch({ type: 'LOG_ERROR' })         
    }
}